<div class="p-4">
    <h2 class="text-xs font-semibold uppercase leading-5 tracking-wide text-grey-dark dark:text-contrast-yellow">
        {{ 'TICKETS_ON_CARD' | translate }}
    </h2>
    <hr class="my-3 h-[1px] bg-black bg-opacity-10 dark:bg-contrast-yellow dark:bg-opacity-100" />
    <ul class="mt-1 flex flex-col gap-4" *ngIf="tickets.length > 0; else noTicketsTemplate">
        <li
            class="rounded-lg border-solid px-4 py-2 dark:border-contrast-yellow dark:border-opacity-100"
            *ngFor="let ticket of tickets"
            [ngClass]="{
                'border border-black border-opacity-10 bg-[#F0F0F0] dark:bg-black': !ticket.validated,
                'border-2 border-primary bg-[#DBF4D8]': ticket.validated
            }">
            <div class="flex items-center gap-2">
                <a
                    class="flex h-full w-full items-center gap-2 text-inherit no-underline hover:no-underline"
                    [routerLink]="('/account/tickets/' | localize) + '/' + ticket.docNumString"
                    [state]="{ ticket: ticket, isCardTicket: true }">
                    <div class="flex items-center">
                        <mat-icon class="!w-8 text-primary" aria-hidden="true" svgIcon="ticket-period"></mat-icon>
                    </div>
                    <div class="flex flex-grow flex-col items-center">
                        <div
                            class="mb-1 flex w-full items-center justify-start gap-2 text-xs opacity-60 dark:opacity-100"
                            [ngClass]="{
                                'sr-app-light:text-secondary pn-light:text-primary pn-app-light:text-primary gl-light:opacity-100 text-[11px] font-semibold  text-secondary dark:text-contrast-yellow':
                                    ticket.validated
                            }">
                            <ng-container *ngIf="!env.SHOW_TICKET_HISTORY_STATUS">
                                {{ (ticket.validated ? 'ACTIVE_TICKET' : 'TICKET') | translate }}
                            </ng-container>

                            <div
                                class="flex items-center justify-center rounded-full border-2 border-solid border-black border-opacity-10 bg-white px-2 dark:border-contrast-yellow"
                                *ngIf="
                                    (ticket.type === TicketProductType.MIXED ||
                                        ticket.type === TicketProductType.DISCOUNT) &&
                                    !env.TICKET_CARD_HIDE_QR_CHIP
                                ">
                                <p class="text-xs opacity-90 dark:text-contrast-yellow dark:opacity-100">
                                    {{ 'QR_CHIP' | translate }}
                                </p>
                            </div>
                        </div>

                        <h3 class="w-full text-base font-bold leading-5">
                            {{ ticket | translateObjectField: 'productTranslations' : translate.currentLang }}
                        </h3>

                        <p
                            class="mt-1 w-full text-xs font-medium leading-4"
                            *ngIf="ticket.starting || hasFixedValidityRange(ticket)">
                            <ng-container *ngIf="hasFixedValidityRange(ticket); else dynamicCardTicketValidity">
                                {{ ticketValidityStart(ticket) | date: 'dd.MM.yyyy HH:mm' }} -
                                {{ ticketValidityEnd(ticket) | date: 'dd.MM.yyyy HH:mm' }}
                            </ng-container>
                            <ng-template #dynamicCardTicketValidity>
                                <ng-container *ngIf="useUnifiedTicketValidityDisplay; else legacyCardTicketValidity">
                                    {{
                                        [ticketValidityStart(ticket), ticketValidityEnd(ticket)]
                                            | ridangoDateTime: ridangoDateTimeOptions(ticket)
                                    }}
                                </ng-container>
                                <ng-template #legacyCardTicketValidity>
                                    {{
                                        ticketValidityStart(ticket)
                                            | formatTimeZone
                                                : (shouldUseDateTimeForQrTicket(ticket)
                                                      ? primaryDateTimeFormat
                                                      : dateTimeFormat)
                                                : timezone
                                    }}
                                    -
                                    {{
                                        ticketValidityEnd(ticket)
                                            | formatTimeZone
                                                : (shouldUseDateTimeForQrTicket(ticket)
                                                      ? primaryDateTimeFormat
                                                      : dateTimeFormat)
                                                : timezone
                                                : null
                                                : null
                                                : true
                                                : ticket
                                    }}
                                </ng-template>
                            </ng-template>
                        </p>

                        <p
                            class="mt-1 w-full text-xs font-medium leading-4"
                            *ngIf="!ticket.starting && !ticket.validated && !hasFixedValidityRange(ticket)">
                            {{ 'TICKET_SUMMARY_V2_VALIDITY_INFO' | translate }}
                        </p>
                    </div>
                </a>
                <div class="flex items-center">
                    <button
                        class="flex items-center md:hidden"
                        [attr.aria-label]="'TICKETS_ON_CARD' | translate"
                        (click)="openTicketPopover(ticket, $event)">
                        <ion-icon
                            class="text-2xl text-secondary dark:text-contrast-yellow"
                            name="ellipsis-vertical"
                            aria-hidden="true">
                        </ion-icon>
                    </button>
                    <button
                        class="hidden items-center md:flex"
                        [attr.aria-label]="'TICKETS_ON_CARD' | translate"
                        (click)="openTicketDesktopPopover(ticket, $event)">
                        <ion-icon
                            class="text-2xl text-secondary dark:text-contrast-yellow"
                            name="ellipsis-vertical"
                            aria-hidden="true">
                        </ion-icon>
                    </button>
                </div>
            </div>
        </li>
    </ul>

    <ng-template #noTicketsTemplate>
        <div class="pt-1 text-center">
            <p class="text-base leading-5 text-grey-dark dark:text-contrast-yellow">
                {{ 'NO_TICKETS_AVAILABLE' | translate }}
            </p>
        </div>
    </ng-template>
</div>
